<template>
    <tr class="animated fadeIn" v-show="removed">
      <td>{{ subscription.listing.name }}</td>
      <td>
        <app-btn :text="subscription.status" />
      </td>
      <td>
        <b-button
          type="button"
          size="sm"
          variant="primary"
          v-on:click="unSubscribe"
          v-show="subscribed === subscription.status"
        ><i class="fa fa-dot-circle-o" ></i>UnSubscribe
        </b-button>
      </td>
    </tr>
</template>
<script>
  import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
  import {Subscription} from "../../../models/NewsLetter/Subscription";
  import AppBtn from "../../base/AppBtn";

  const SubscriptionRepo = RepositoryFactory.get('newsletterSubscribe')

  export default {
    name: 'subscription-item',
    components: {AppBtn},
    props: {
            subscription: {
                type: Subscription,
                default: new Subscription(),
            },
      },
      data() {
          return {
              removed: true,
              subscribed: Subscription.STATUS.SUBSCRIBED,
          }
      },
      methods: {
          unSubscribe() {
              SubscriptionRepo
                  .unSubscribe(this.subscription.id)
                  .then(
                      () => {
                          this.removed = false
                      }
                  )
          }
      },
  }
</script>
